import { Link } from '@inertiajs/react'
import Layout from './Layout'

export default function Landing() {
  return (
    <Layout>
      <div className="text-center py-20">
        <h1 className="text-5xl font-bold text-[#202020] mb-6">
          esmipos
        </h1>
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          Sistema de punto de venta moderno y fácil de usar para tu negocio.
          Gestiona productos, ventas y clientes desde cualquier lugar.
        </p>
        <div className="space-x-4">
          <Link
            href="/registrations/new"
            className="bg-[#FFC107] text-[#202020] px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#e6ad06] transition-colors"
          >
            Crear cuenta gratis
          </Link>
          <Link
            href="/session/new"
            className="bg-[#55ACEE] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#4a9dd4] transition-colors"
          >
            Iniciar sesión
          </Link>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white p-6 rounded-lg shadow">
            <div className="text-4xl mb-4">📦</div>
            <h3 className="text-xl font-semibold text-[#202020] mb-2">Gestión de Productos</h3>
            <p className="text-gray-600">Importa productos desde Excel, organiza por categorías y controla el inventario.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <div className="text-4xl mb-4">💰</div>
            <h3 className="text-xl font-semibold text-[#202020] mb-2">Punto de Venta</h3>
            <p className="text-gray-600">Interfaz rápida y sencilla para procesar ventas con múltiples métodos de pago.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <div className="text-4xl mb-4">📊</div>
            <h3 className="text-xl font-semibold text-[#202020] mb-2">Reportes</h3>
            <p className="text-gray-600">Visualiza ventas diarias, mensuales y productos más vendidos.</p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-3">¿Eres comprador?</p>
          <Link
            href="/esmipos/catalog"
            className="text-[#55ACEE] hover:underline text-sm font-medium"
          >
            Ir a la tienda →
          </Link>
        </div>
      </div>
    </Layout>
  )
}
